/**
 * Статусы primary_lighten(1-3) - взяты из настроек цветов вьютифая (см. colors.scss).
 * Carbonado === primary_lighten(1-3)
 * все цвета primary_lighten(1-3) - БЕЗ заливки
 */
export enum ChipStatuses {
  /**
   * success - цвет: #D5F5C5 ($success_lighten3) с заливкой
   */
  SUCCESS = 'success',

  /**
   * canceled - цвет: #f6f7fa ($primary_lighten5) с заливкой
   */
  CANCELED = 'canceled',

  /**
   * done - цвет: #D0FAE8 (НЕ из палитры в макете) с заливкой
   * используется в статусах новостей/баннеров в обозначении "Опубликован"
   */
  DONE = 'done',

  /**
   * error - цвет: #f5dce0 ($error_lighten4) с заливкой. используется и как "отмена", и как "новый"
   */
  ERROR = 'error',

  /**
   * warning - цвет: #FEF7E4
   */
  WARNING = 'warning',

  /**
   * new - цвет: #edeff5 ($primary_lighten4) без заливки. используется в статусах заказа/проекта
   */
  NEW = 'new',

    /**
   * new - цвет: #edeff5 ($primary_lighten4) без заливки, но с тем же цветом шрифта
   */
  LIGHT = 'light',

  /**
   * цвет: #dce0eb ($primary_lighten3) без заливки
   */
  LIGHTEN_3 = 'primary_lighten3',

  /**
   * цвет: #c9cddd ($primary_lighten2), без заливки
   */
  LIGHTEN_2 = 'primary_lighten2',

  /**
   * цвет: #b2b7ca ($primary_lighten1), без заливки
   */
  LIGHTEN_1 = 'primary_lighten1',
}
